import React from 'react'
import { useTableContext } from '../Context'

export const TableFooter = () => {
  const { foot } = useTableContext()

  return <tfoot>{foot}</tfoot>
}
